import Vue from 'vue'
import master from '../masterModules/masterMutation.js'
// location-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  inputAddUpdate(store, payload) {
    store.commit('inputAddUpdate', payload)
  },
  clearLocation(store) {
    store.commit('clearLocation')
  },
  updateSelectedLocationList(store, payload) {
    store.commit('updateSelectedLocationList', payload)
  },
  clearSelectedLocationList(store) {
    store.commit('clearSelectedLocationList')
  },
  async addLocation(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    store.state.addLocation['foothold'] = true
    const data = {
      header,
      data: [
        {
          users: [store.state.addLocation]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/location/regist',
      data,
      config
    )
    // 成功
    // 追加後の処理
    store.commit('setLocations', response)
  },
  async setLocations(store, payload) {
    store.state.locations = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          users: [{foothold: true}],
          pageNo: payload.pageNo,
          count: 20,
          searchWord: payload.searchWord
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/location/list',
      data,
      config
    )
    // 成功
    store.commit('setLocations', response)
  },
  async updateLocation(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [
        {
          users: [store.state.updateLocation]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/location/update',
      data,
      config
    )
    // 成功
    // 更新後の処理
    store.commit('setLocations', response)
  },
  async deleteLocations(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [
        {
          users: payload
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/location/delete',
      data,
      config
    )
    // 成功
    // 削除後の処理
    await store.commit('setLocations', response)
  },
  async setDetailLocation(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          users: [
            {
              userId: payload.userId,
              foothold: true
            }
          ]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/location/detail',
      data,
      config
    )
    // 成功
    store.commit('setDetail', response)
  },
  async importLocations(store, payload) {
    let logContinue = true
    let pageNo = 0
    const count = 200
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: [
          {
            users: payload.slice(pageNo * count, pageNo * count + count),
            startFlag: pageNo === 0,
            endFlag: false
          }
        ]
      }

      const size = payload.length
      pageNo++
      if (size <= pageNo * count) {
        data.data[0].endFlag = true
        logContinue = false
      }

      await Vue.http.post(URL + '/v2/admin/location/import', data, config)
    }
  },
  async setExportData(store, payload) {
    let logContinue = true
    let pageNo = 0
    const count = 200
    const margeData = {
      data: {
        header: {},
        data: []
      }
    }
    let totalCount = 0
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: payload.selectedLocationIdList.slice(
          pageNo * count,
          pageNo * count + count
        ),
        pageNo: payload.selectedLocationIdList.length === 0 ? pageNo : 0,
        count: count,
        searchWord: payload.searchWord
      }
      var response = await Vue.http.post(
        URL + '/v2/admin/location/export',
        data,
        config
      )

      const size = response.data['data'].length
      totalCount += size
      for (let i = 0; i < size; i++) {
        margeData.data.data.push(response.data['data'][i])
      }
      pageNo++
      if (size < count) {
        margeData.data.header = response.data['header']
        logContinue = false
      }
      if (payload.selectedLocationIdList.length > 0 && totalCount >= payload.selectedLocationIdList.length) {
        margeData.data.header = response.data['header']
        logContinue = false
      }
    }

    // 成功
    // 追加後の処理
    store.commit('setExportData', margeData)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/placeModules/actions.js